var gridCellDateFormatter = function (field) {
    return function (record) {
        if (record[field]) {
            var date = moment(record[field]);
            return date.format('DD.MM.YYYY');
        }

        return '-';
    };
};

var buttonsHandler = function (gridId) {
    return function (target, data) {
        var grid = w2ui[gridId];
        var event = data.originalEvent;
        event.stopPropagation();
        var selectedClients = grid.getSelection();

        if (target == 'manager-change') {
            if (selectedClients.length == 0) {
                alert('Необходимо выбрать хотя бы одного клиента');
                return;
            }

            $('div.modal-window').hide();
            var $managerSelectWindow = $('#manager-select-window');
            $managerSelectWindow.find('select option').removeAttr("selected");
            $managerSelectWindow.show();

            $("#clientsManager_setManager").off('click').on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                var managerId = $("#clientsManager_manager").val();
                $.post(
                    Routing.generate("app_client_clientsimplerest_batchchangemanager"),
                    {'clients': selectedClients, 'manager': managerId},
                    function (data) {
                        if (!data.success) {
                            alert('Ошибка при изменении!');
                        }

                        window.location.reload();
                    }
                )
            });
        } else if (target == 'send-list') {
            var currentFilter = grid.searchData;
            $.post(
                Routing.generate('app_client_clientsimplerest_getidbyfilter'),
                {'filter': currentFilter}
            );
        }
    };
};

var initializeGrid = function (columns, baseFilter, gridId, sortData) {
    var columnsList = {
        id: {field: 'id', caption: 'id', size: '40px', 'sortable': true, hidden: true},
        special: {
            field: 'special',
            caption: '',
            size: '2px',
            resizable: false,
            'sortable': false,
            render: function (record) {
                if (record.special) {
                    return '<div class="place-special" title="Спецразмещение"></div>"'
                }
                return '';
            }
        },
        name: {
            field: 'name',
            caption: 'Название',
            size: '20%',
            sortable: true,
            render: function (record) {
                var text = '<span class="client-name">' + record.name + '</span>';
                if (record.full_address) {
                    text += '<br><span class="grid_address">' + record.full_address + '</span>'
                }

                return text;
            }
        },
        tasks: {
            field: 'uncomplete_tasks',
            caption: 'Задачи',
            size: '200px',
            sortable: true,
            render: function (record) {
                if (record.uncomplete_tasks) {
                    var text = [];
                    $.each(record.uncomplete_tasks, function (i, task) {
                        var date = moment(task.happen_at).format('DD.MM.YYYY');
                        text.push('<span style="color: #ff2b1d;font-size: 10px;">' + date + ' ' + task.content + '</span><br>');
                    });

                    return text.join('<br>');
                }
            }
        },
        turnover: {
            field: 'turnover',
            caption: 'Оборот за 12 месяцев',
            size: '100px',
            sortable: true,
            render: function (record) {
                if (record.turnover) {
                    return record.turnover;
                }
            }
        },
        onSite: {
            field: 'onSite',
            caption: 'Связь',
            size: '60px',
            sortable: true,
            render: function (record) {
                if (record.premium) {
                    return '<img src="/assets/images/icons/paid.png" title="Платник">';
                } else if (!record.site_url) {
                    return '';
                } else {
                    return '<img src="/assets/images/icons/connected.png" title="Не платник">';
                }
            }
        },
        paidStatus: {
            field: 'paidStatus',
            caption: 'Статус',
            size: '60px',
            sortable: false,
            render: function (record) {
                if (record.have_active_services) {
                    return 'Платник';
                } else if (record.have_paid_services_in_all_time) {
                    return 'Бывший платник';
                } else if (record.have_active_pro_user) {
                    return 'Тёпленкий';
                } else {
                    return 'Неплатник';
                }
            }
        },
        onSiteActivity: {
            field: 'onSiteActivity',
            caption: 'Активность',
            size: '60px',
            sortable: true,
            render: function (record) {
                return '<div class="targets">' + record.on_site_activity.join('<br>') + '</div>';
            }
        },
        onSiteTraffic: {
            field: 'onSiteTraffic',
            caption: 'Толпа',
            size: '60px',
            sortable: true,
            hidden: true,
            render: function (record) {
                if (record.on_site_traffic) {
                    return '<div class="targets" title="Уникальных посетителей за 7 дней: ' + record.on_site_traffic + '">толпа</div>'
                }

                return '';
            }
        },
        onSiteProLogin: {
            field: 'onSiteProLogin',
            caption: 'Прошка',
            size: '60px',
            sortable: true,
            hidden: true,
            render: function (record) {
                if (record.on_site_pro_login) {
                    return '<div class="targets" title="Последний логин про-пользователя: ' + record.on_site_pro_login + '">прошка</div>'
                }

                return '';
            }
        },
        onSiteReview: {
            field: 'onSiteReview',
            caption: 'Отзыв',
            size: '60px',
            sortable: true,
            hidden: true,
            render: function (record) {
                if (record.on_site_review) {
                    return '<div class="targets" title="Последний отзыв: ' + record.on_site_review + '">отзыв</div>';
                }

                return '';
            }
        },
        onSiteOrders: {
            field: 'onSiteOrders',
            caption: 'Брони',
            size: '60px',
            sortable: true,
            hidden: true,
            render: function (record) {
                if (record.on_site_orders) {
                    return '<div class="targets" title="Броней за последние две недели: ' + record.on_site_orders + '">брони</div>'
                }

                return '';
            }
        },
        onSiteCabinet: {
            field: 'onSiteCabinetVisit',
            caption: 'Кабинет',
            size: '60px',
            sortable: true,
            hidden: true,
            render: function (record) {
                if (record.on_site_cabinet_visit) {
                    return '<div class="targets" title="Заходил в кабинет последние 2 недели: ' + record.on_site_cabinet_visit + '">кабинет</div>'
                }

                return '';
            }
        },
        actual_contacts: {field: 'actual_contacts', caption: 'Актуальные контакты', size: '40%'},
        manager_name: {field: 'manager_name', caption: 'Менеджер', size: '150px', sortable: true},
        previous_manager_name: {
            field: 'previous_manager_name',
            caption: 'Последний',
            size: '150px',
            'sortable': true
        },
        last_manager_comment_date_at: {
            field: 'last_manager_comment_date_at',
            caption: 'Посл. актив.',
            size: '100px',
            sortable: true,
            render: gridCellDateFormatter('last_manager_comment_date_at')
        },
        manager_deleted_at: {
            field: 'manager_deleted_at',
            caption: 'Слетело',
            size: '90px',
            sortable: true,
            render: gridCellDateFormatter('manager_deleted_at')
        },
        updated_at: {
            field: 'updated_at',
            caption: 'Изменен',
            size: '90px',
            sortable: true,
            render: gridCellDateFormatter('updated_at')
        },
        close_button: {
            field: 'close_button',
            size: '10px',
            render: function (record) {
                return '<img src="/assets/images/icons/close-icon.png" class="grid-close">'
            },
            attr: 'data-noclick="1"'
        },
        deactivate_button: {
            field: 'deactivate_button',
            size: '10px',
            render: function () {
                return '<div class="grid-deactivate">_</div>'
            },
            attr: 'data-noclick="1"'
        },
        working_status: {
            field: 'working_status',
            caption: 'Что делаю',
            sortable: true,
            size: '100px',
            render: function (record) {
                if (record.working_status == 0) {
                    return '<span class="td-status-workin">Под опекой</span>';
                } else if (record.working_status == 1) {
                    return '<span class="td-status-suspend">Пора проведать</span>';
                }

                return '<span class="td-status-nowork">Готов отдать</span>';
            }
        },
        working_status_with_new_client: {
            field: 'working_status_with_new_client',
            caption: 'Что делаю',
            sortable: true,
            size: '130px',
            render: function (record) {
                if (record.working_status == 0) {
                    return '<span class="td-status-workin">Ведется</span>';
                } else if (record.working_status == 1) {
                    return '<span class="td-status-suspend">Подзабил</span>';
                }

                return '<span class="td-status-nowork">Ничего не делаю</span>';
            }
        },
        has_contractors: {
            field: 'has_contractors',
            caption: 'Линк',
            sortable: true,
            size: '50px',
            render: function (record) {
                if (record.has_services) {
                    return '<img class="open-transaction-tab" data-tab="transactions" src="/assets/images/icons/ok_icon.jpg">';
                }

                if (record.has_contractors) {
                    return '<img class="open-transaction-tab" data-tab="transactions" src="/assets/images/icons/link.png">';
                }

                return '<img class="open-transaction-tab" src="/assets/images/icons/unlink.png">';
            }
        },
        last_manager_comment: {
            field: 'last_manager_comment',
            caption: 'Посл. актив.',
            sortable: true,
            size: '30%',
            render: function (record) {
                var date;
                if (record.last_manager_comment_date_at) {
                    date = moment(record.last_manager_comment_date_at).fromNow();
                } else {
                    date = '-';
                }
                return '<b>' + date + '</b> <br>' + record.last_manager_comment_text;
            }
        },
        days_in_work: {
            field: 'days_in_work',
            caption: 'Дней в работе',
            sortable: true,
            size: '50px'
        },
        days_to_work_left: {
            field: 'days_to_work_left',
            caption: 'Осталось',
            sortable: true,
            size: '50px',
            render: function (record) {
                var days = record.days_to_work_left;
                var text = '';
                if (days <= 10) {
                    return '<img src="/assets/images/icons/icon_warning.png"> <span style="color: red;">' + days + '</span> ';
                } else if (days) {
                    return '<span>' + days + '</span>';
                }

                return '';
            },
            attr: 'data-noclick="1"'
        },
        client_type: {
            field: 'client_type',
            caption: 'Тип клиента',
            sortable: true,
            size: '100px',
            hidden: true,
            render: function (record) {
                if (record.client_type) {
                    if (record.client_type == 1) {
                        return 'Рекламное агентство';
                    } else if (record.client_type == 6) {
                        return 'Рекламное агентство (соцсети)';
                    } else if (record.client_type == 2) {
                        return 'Поставщик Horeca';
                    } else if (record.client_type == 3) {
                        return 'Непрофильный рекламодатель';
                    } else if (record.client_type == 4) {
                        return 'Служба доставки';
                    } else if (record.client_type == 5) {
                        return 'Заведение';
                    }
                }
            }
        },
        actualServices: { field: 'actual_services', caption: 'Услуги', size: '40%', sortable: true }
    };

    var gridColumns = [];
    $.each(columns, function (i, e) {
        var column = $.extend({}, columnsList[i]);
        if (typeof(e) == 'object') {
            $.each(e, function (i, e) {
                column[i] = e;
            });
        } else {
            column.size = e;
        }
        gridColumns.push(column);
    });

    var userRole = $("body").data('user-role');
    var roles = $("body").data('user-roles');
    var userId = $("body").data('user-id');
    var isAdmin = roles.includes('ROLE_SUPER_ADMIN');
    var toolbarButtons = [
        {type: 'break'}
    ];
    if (isAdmin) {
        toolbarButtons.push(
            {
                type: 'button',
                id: 'manager-change',
                caption: 'Поменять менеджера выбранным клиентам',
                img: 'fa fa-user'
            }
        );
    }
    toolbarButtons.push(
        {
            type: 'button',
            id: 'send-selected',
            caption: 'Рассылка по выбранным клиентам',
            img: 'fa fa-clone'
        }
    );
    toolbarButtons.push(
        {type: 'button', id: 'send-list', caption: 'Рассылка по всему списку', img: 'fa fa-truck'}
    );

    var $grid = $('#myGrid');
    $grid.w2grid({
        name: gridId,
        url: Routing.generate("api_grid_client"),
        show: {
            toolbar: true,
            footer: true,
            selectColumn: true
        },
        toolbar: {
            items: toolbarButtons,
            onClick: buttonsHandler(gridId)
        },
        multiSelect: true,
        columns: gridColumns,
        recid: 'id',
        reorderColumns: true,
        onClick: function (event) {
            event.preventDefault();
            var grid = this;
            var record = grid.get(event.recid);
            var target = $(event.originalEvent.target);

            if (target.attr('class') == 'grid-close') {
                var ok = false;
                if (record.status == 5) { //Заведение уже закрыто
                    ok = confirm('Перенести заведение "' + record.name + '" в открытые?');
                } else {
                    ok = confirm('Перенести заведение "' + record.name + '" в закрытые?');
                }

                if (ok) {
                    $.post(Routing.generate('clients_close', {id: event.recid}), function () {
                        window.location.reload();
                    });
                }
            } else if (target.attr('class') == 'grid-deactivate') {
                if (confirm('Деактивировать заведение "' + record.name + '?')) {
                    $.post(Routing.generate('clients_deactivate', {id: event.recid}), function () {
                        window.location.reload();
                    });
                }
            }

            if (target.closest('td').data('noclick')) {
                return;
            } else if (target.data('tab')) {
                window.open(Routing.generate('clients_show', {id: event.recid}) + '#' + target.data('tab'), '_blank');

                return;
            }

            window.open(Routing.generate('clients_show', {id: event.recid}), '_blank');
        },
        searches: [],
        searchData: baseFilter,
        onSearch: function (event) {
            if (event.searchData.length > 0) {
                var searchText = event.searchData[0].value;
                event.searchData = [{'field': 'search', 'value': searchText}];
                for (var i in baseFilter) {
                    event.searchData.push($.extend({}, baseFilter[i]));
                }

            } else {
                for (var i in baseFilter) {
                    event.searchData.push($.extend({}, baseFilter[i]));
                }
            }
        },
        onChange: function () {
            this.save();
        },
        selectColumn: true,
        sortData: sortData
    });
};